
// import { useNavigate } from "react-router-dom";
// import "./Get_In_Touch.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faPhone,
//   faEnvelope,
//   faLocationDot,
// } from "@fortawesome/free-solid-svg-icons";
// import Send_Msg_Modal from "./send-msg-modal/Send_Msg_Modal";

// const Get_In_Touch = () => {
//   const navigate = useNavigate();
//   const [showModal, setShowModal] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//    const handleSendMsgClick = () => {
//         setShowModal(true);
//     };


//   const [formData, setFormData] = useState({
//     fname: "",
//     lname: "",
//     phone: "",
//     email: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.id]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     const htmlFormat = `
//         <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
//           <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
//             📩 New Contact Form Submission
//           </h2>
//           <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
//             <tr>
//               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
//               <td style="padding: 10px; border: 1px solid #ddd;">${formData.fname} ${formData.lname}</td>
//             </tr>
//             <tr>
//               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
//               <td style="padding: 10px; border: 1px solid #ddd;">${formData.email}</td>
//             </tr>
//             <tr>
//               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Phone</td>
//               <td style="padding: 10px; border: 1px solid #ddd;">${formData.phone}</td>
//             </tr>
//             <tr>
//               <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
//               <td style="padding: 10px; border: 1px solid #ddd;">${formData.message}</td>
//             </tr>
//           </table>
//         </div>`;

//     const payload = {
//       email: "vaishnavis.cse21d@sbjit.edu.in",
//       subject: `Website Inquiry: ${formData.fname} ${formData.lname}`,
//       html: htmlFormat,
//       key: "Profcyma",
//     };

//     try {
//       const response = await fetch(
//         "https://emailservices.hostelbliss.com:3301/common-email",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(payload),
//         },
//       );

//       if (response.ok) {
//         setShowModal(true);
//         setFormData({
//           fname: "",
//           lname: "",
//           phone: "",
//           email: "",
//           message: "",
//         });

//         setTimeout(() => {
//           setShowModal(false);
//           navigate("/");
//         }, 2500);
//       } else {
//         const errorResult = await response.json();
//         console.error("Submission failed:", errorResult);
//       }
//     } catch (error) {
//       console.error("Network error:", error);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div className="get-touch-wrapper">
//       <div className="container">
 

//         <div className="get-touch-card">
//           <div className="get-touch-left">
//             <h2>GET IN TOUCH</h2>
//             <div className="contact-item">
//               <span className="icon">
//                 <FontAwesomeIcon icon={faPhone} />
//               </span>
//               <span>+91 9954878569</span>
//             </div>
//             <div className="contact-item">
//               <span className="icon">
//                 <FontAwesomeIcon icon={faEnvelope} />
//               </span>
//               <span>Support@olltypeservice.com</span>
//             </div>
//             <div className="contact-item">
//               <span className="icon">
//                 <FontAwesomeIcon icon={faLocationDot} />
//               </span>
//               <span>Bangalore, India</span>
//             </div>
//           </div>

//           <form className="get-touch-right" onSubmit={handleSubmit}>
//             <div className="form-row">
//               <div className="input-group">
//                 <input
//                   type="text"
//                   id="fname"
//                   value={formData.fname}
//                   onChange={handleChange}
//                   placeholder=" "
//                   required
//                 />
//                 <label htmlFor="fname">First Name</label>
//               </div>
//               <div className="input-group">
//                 <input
//                   type="text"
//                   id="lname"
//                   value={formData.lname}
//                   onChange={handleChange}
//                   placeholder=" "
//                 />
//                 <label htmlFor="lname">Last Name</label>
//               </div>
//             </div>

//             <div className="form-row">
//               <div className="input-group">
//                 <input
//                   type="text"
//                   id="phone"
//                   value={formData.phone}
//                   onChange={handleChange}
//                   placeholder=" "
//                 />
//                 <label htmlFor="phone">Phone No.</label>
//               </div>
//               <div className="input-group">
//                 <input
//                   type="email"
//                   id="email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   placeholder=" "
//                   required
//                 />
//                 <label htmlFor="email">Email Id</label>
//               </div>
//             </div>

//             <div className="input-group">
//               <textarea
//                 id="message"
//                 value={formData.message}
//                 onChange={handleChange}
//                 placeholder=" "
//                 required
//               ></textarea>
//               <label htmlFor="message">Message</label>
//             </div>

//             <div className="btn-container">
//               <button onClick={handleSendMsgClick}
//                 type="submit"
//                 className="send-btn"
//                 disabled={isSubmitting}
//               >
//                 {isSubmitting ? "Sending..." : "Send Message"}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//          <Send_Msg_Modal
//                 showSendMsg={showModal}
//                 handleSendMsgClose={() => setShowModal(false)}
//             />
//     </div>
//   );
// };

// export default Get_In_Touch;
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Get_In_Touch.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import Send_Msg_Modal from "./send-msg-modal/Send_Msg_Modal";

const Get_In_Touch = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const htmlFormat = `
        <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
          <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
            📩 New Contact Form Submission
          </h2>
          <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${formData.fname} ${formData.lname}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${formData.email}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Phone</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${formData.phone}</td>
            </tr>
            <tr>
              <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
              <td style="padding: 10px; border: 1px solid #ddd;">${formData.message}</td>
            </tr>
          </table>
        </div>`;

    const payload = {
      email: "vaishnavis.cse21d@sbjit.edu.in",
      subject: `Website Inquiry: ${formData.fname} ${formData.lname}`,
      html: htmlFormat,
      key: "Profcyma",
    };

    try {
      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        // --- SHOW MODAL ONLY ON SUCCESS ---
        setShowModal(true);
        
        // Reset form
        setFormData({
          fname: "",
          lname: "",
          phone: "",
          email: "",
          message: "",
        });

    
        setTimeout(() => {
          setShowModal(false);
          navigate("/");
        }, 2500);
      } else {
        const errorResult = await response.json();
        alert("Failed to send message. Please try again.");
        console.error("Submission failed:", errorResult);
      }

   
    } catch (error) {
      console.error("Network error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="get-touch-wrapper">
      <div className="container">
        <div className="get-touch-card">
          <div className="get-touch-left">
            <h2>GET IN TOUCH</h2>
            <div className="contact-item">
              <span className="icon"><FontAwesomeIcon icon={faPhone} /></span>
              <span>+91 9954878569</span>
            </div>
            <div className="contact-item">
              <span className="icon"><FontAwesomeIcon icon={faEnvelope} /></span>
              <span>Support@olltypeservice.com</span>
            </div>
            <div className="contact-item">
              <span className="icon"><FontAwesomeIcon icon={faLocationDot} /></span>
              <span>Bangalore, India</span>
            </div>
          </div>

          <form className="get-touch-right" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="input-group">
                <input type="text" id="fname" value={formData.fname} onChange={handleChange} placeholder=" " required />
                <label htmlFor="fname">First Name</label>
              </div>
              <div className="input-group">
                <input type="text" id="lname" value={formData.lname} onChange={handleChange} placeholder=" " />
                <label htmlFor="lname">Last Name</label>
              </div>
            </div>

            <div className="form-row">
              <div className="input-group">
                <input type="text" id="phone" value={formData.phone} onChange={handleChange} placeholder=" " />
                <label htmlFor="phone">Phone No.</label>
              </div>
              <div className="input-group">
                <input type="email" id="email" value={formData.email} onChange={handleChange} placeholder=" " required />
                <label htmlFor="email">Email Id</label>
              </div>
            </div>

            <div className="input-group">
              <textarea id="message" value={formData.message} onChange={handleChange} placeholder=" " required></textarea>
              <label htmlFor="message">Message</label>
            </div>

            <div className="btn-container">
              {/* REMOVED onClick={handleSendMsgClick} */}
              <button 
                type="submit" 
                className="send-btn" 
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* MODAL INTEGRATION */}
      <Send_Msg_Modal
        showRequestSent={showModal} // Prop name from your Modal component
        handleRequestSendClose={() => setShowModal(false)} // Prop name from your Modal component
      />
    </div>
  );
};

export default Get_In_Touch;
